<script>
export default {
  name: "termPage"
}
</script>

<template>
<div class="term-page" v-if="$i18n.locale === 'en'">
  <div class="container">
    <h4 class="title">Terms of Use</h4>
    <p>Effective Date: from 23<sup>rd</sup> October, 2014</p>
    <p class="mt-3">The Disclaimer of this website (<span><a href="https://www.ppmember.com">www.ppmember.com</a></span>)
      has been translated into Chinese. In case of inconsistency or ambiguity between the English and Chinese versions, the English version shall prevail.
    </p>
    <h5 class="mt-4">Disclaimer</h5>
    <p class="mt-3">The information provided by Monkey Tree English Learning Center Limited (“Monkey Tree English Learning Center”, “Monkey Tree”, “MTELC”, “we”, “us”, or “our”) and our schools on our official website
      (<span><a href="https://www.ppmember.com">www.ppmember.com</a></span>)
      is for general information only.
    </p>
    <p class="mt-3">We will, as manageable by our best effort, keep all content contained in our website up-to-date. However, content contained in our website is subject to review and changes without notice.</p>
    <p class="mt-3">We shall not be deemed responsible for inaccurate information, nor any damage or loss caused by information on this website.</p>
    <h5 class="mt-4">Changes to this Disclaimer</h5>
    <p class="mt-3">We update our Disclaimer from time to time without prior notice. We encourage you to check this Website occasionally to ensure that you are aware of the most recent terms.</p>
    <h5 class="mt-4">Copyright Statement</h5>
    <p class="mt-3">Unless specified otherwise, we are the owner of the copyright of all content available on this website.</p>
    <p class="mt-3">All contents of this website, including text, graphics, photos, files and information this website for public or commercial purposes in any manner without the written consent from Monkey Tree is strictly prohibited.</p>
  </div>
</div>
  <div class="term-page" v-else-if="$i18n.locale === 'zh-CN'">
    <div class="container">
      <h4 class="title">网站使用条款</h4>
      <p>本声明自2014年10月23日起生效</p>
      <p class="mt-3">本网站(<span><a href="https://www.ppmember.com">www.ppmember.com</a></span>)
        声明，本域名下的中文内容是根据英文之翻译版本，如若出现解释模糊，定义不清的情况，内容以英文为准。
      </p>
      <h5 class="mt-4">免责声明</h5>
      <p class="mt-3">载于
        (<span><a href="https://www.ppmember.com">www.ppmember.com</a></span>)
        网站的所有资料只供一般参阅 而并非法律意见或其他专业意见, 亦不得作为此等意见的依据。
      </p>
      <p class="mt-3">我们会对本网站的内容进行即时更新以便管理，但网站上内容因更新而做出的修改恕不另行通知。</p>
      <p class="mt-3">我们不会因为载于网站上的信息错误而导致的损失承担任何责任。</p>
      <h5 class="mt-4">声明变更</h5>
      <p class="mt-3">我们会不定时对本网站的各项声明进行更新，更新前亦不会做出通知。您可以经常登录本网站已查询最新条款。</p>
      <h5 class="mt-4">版权声明</h5>
      <p class="mt-3">除特殊声明外，载于本网站上的一切资料之版权归本网站所有。</p>
      <p class="mt-3">本网站所载一切资料包括（文字、照片、图画 等）仅限于个人以及非商业之用途。相关资料未经Monkey Tree同意，禁止用于公共及其他商业用途。</p>
    </div>
  </div>
  <div class="term-page" v-else>
    <div class="container">
      <h4 class="title">網站使用條款</h4>
      <p>本聲明自2014年10月23日起生效</p>
      <p class="mt-3">本網站 (<span><a href="https://www.ppmember.com">www.ppmember.com</a></span>)
        聲明，本域名下的中文內容是根據英文之翻譯版本，如若出現解釋模糊，定義不清的情況，內容以英文為準。
      </p>
      <h5 class="mt-4">免責聲明</h5>
      <p class="mt-3">載於
        (<span><a href="https://www.ppmember.com">www.ppmember.com</a></span>)
        網站的所有資料只供一般參閱 而並非法律意見或其他專業意見, 亦不得作為此等意見的依據。
      </p>
      <p class="mt-3">我們會對本網站的內容進行即時更新以便管理，但網站上內容因更新而做出的修改恕不另行通知。</p>
      <p class="mt-3">我們不會因為載於網站上的信息錯誤而導致的損失承擔任何責任。</p>
      <h5 class="mt-4">聲明變更</h5>
      <p class="mt-3">我們會不定時對本網站的各項聲明進行更新，更新前亦不會做出通知。您可以經常登錄本網站已查詢最新條款。</p>
      <h5 class="mt-4">版權聲明</h5>
      <p class="mt-3">除特殊聲明外，載於本網站上的一切資料之版權歸本網站所有。</p>
      <p class="mt-3">本網站所載一切資料包括（文字、照片、圖畫 等）僅限于個人以及非商業之用途。相關資料未經Monkey Tree同意，禁止用於公共及其他商業用途。</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.term-page{
  padding-top: 8%;
  padding-bottom: 5%;
  @include media-max(xxl){
    padding: 10% 55px 20%;
  }
  h4{
    margin: 70px 0 50px 0;
    font-size: 1.5rem;
    font-weight: 500;
    &:before{
      content: "";
      display: inline-block;
      width: 3px;
      height: 16px;
      background: #009539;
      margin-right: 12px;
    }
  }
  h5{
    font-size: 1.25rem;
    font-weight: 500;
  }
  a{
    color: #485154;
  }
}
</style>